var map = {
	"./application7-1.jpg": "/JCj",
	"./application7-2.jpg": "nC1L",
	"./application7-3.jpg": "yEr2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZftE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application7 ^\.\/.*$
// module id = ZftE
// module chunks = 0